export default {
    OUTRAS : 'Outras',
    VOLUNTARIAS : 'Voluntárias'
}
